/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListChatSourcesSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListChatSourcesSecurityOption2 = {
  chatSessionsTokenHeaderGramChatSession: string;
};

export type ListChatSourcesSecurity = {
  option1?: ListChatSourcesSecurityOption1 | undefined;
  option2?: ListChatSourcesSecurityOption2 | undefined;
};

export type ListChatSourcesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
};

/** @internal */
export type ListChatSourcesSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListChatSourcesSecurityOption1$outboundSchema: z.ZodMiniType<
  ListChatSourcesSecurityOption1$Outbound,
  ListChatSourcesSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listChatSourcesSecurityOption1ToJSON(
  listChatSourcesSecurityOption1: ListChatSourcesSecurityOption1,
): string {
  return JSON.stringify(
    ListChatSourcesSecurityOption1$outboundSchema.parse(
      listChatSourcesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListChatSourcesSecurityOption2$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
};

/** @internal */
export const ListChatSourcesSecurityOption2$outboundSchema: z.ZodMiniType<
  ListChatSourcesSecurityOption2$Outbound,
  ListChatSourcesSecurityOption2
> = z.pipe(
  z.object({
    chatSessionsTokenHeaderGramChatSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
    });
  }),
);

export function listChatSourcesSecurityOption2ToJSON(
  listChatSourcesSecurityOption2: ListChatSourcesSecurityOption2,
): string {
  return JSON.stringify(
    ListChatSourcesSecurityOption2$outboundSchema.parse(
      listChatSourcesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListChatSourcesSecurity$Outbound = {
  Option1?: ListChatSourcesSecurityOption1$Outbound | undefined;
  Option2?: ListChatSourcesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListChatSourcesSecurity$outboundSchema: z.ZodMiniType<
  ListChatSourcesSecurity$Outbound,
  ListChatSourcesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListChatSourcesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListChatSourcesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listChatSourcesSecurityToJSON(
  listChatSourcesSecurity: ListChatSourcesSecurity,
): string {
  return JSON.stringify(
    ListChatSourcesSecurity$outboundSchema.parse(listChatSourcesSecurity),
  );
}

/** @internal */
export type ListChatSourcesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
};

/** @internal */
export const ListChatSourcesRequest$outboundSchema: z.ZodMiniType<
  ListChatSourcesRequest$Outbound,
  ListChatSourcesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      gramChatSession: "Gram-Chat-Session",
    });
  }),
);

export function listChatSourcesRequestToJSON(
  listChatSourcesRequest: ListChatSourcesRequest,
): string {
  return JSON.stringify(
    ListChatSourcesRequest$outboundSchema.parse(listChatSourcesRequest),
  );
}
